/* eslint-disable no-unused-vars */
import store from 'store';
import uuid from 'react-uuid';
import { creativesActions } from 'store/actions';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE, NEW_CAMP_STAB_DEFAULT_TRACKING } from 'constants';

export function sortByDate(arrayCollection) {
  // Use the sort() method to sort the array by the 'upload_date' key
  arrayCollection.sort(function (a, b) {
    // Convert the date strings to Date objects for comparison
    const dateA = new Date(a.upload_date);
    const dateB = new Date(b.upload_date);

    // Compare the dates
    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      return 0;
    }
  });

  return arrayCollection;
}

export const sortCreativeItems = (creativesList) => {
  const sortedObjects = creativesList.toSorted((a, b) => {
    if (a.status === 0) return -1;
    if (b.status === 0) return 1;
    if (a.status === 1 && b.status !== 0) return -1;
    if (b.status === 1 && a.status !== 0) return 1;
    return a.status - b.status;
  });
  return sortedObjects;
};

export const getVideoSrc = (item) => {
  const order = [
    'file_name_low',
    'file_name_normal',
    'file_name_original',
    'file_name_big',
    'file_name_high',
  ];
  for (const size of order) {
    if (item[size]) return item[size];
  }
  return null;
};

export const createCreativesListAndTrackingForDefaultItem = (creativeAndTrackingData) => {
  const dispatch = store.dispatch;
  const newTmpCreativeId = uuid();
  let newCreativeListData = [];
  let newTmpCreative = structuredClone(NEW_CAMP_STAB_DEFAULT_CREATIVE);
  newTmpCreative.bn_bannerid = newTmpCreativeId;
  newTmpCreative.tmp_id = newTmpCreativeId;
  newTmpCreative.title =
    creativeAndTrackingData?.app_name_full || creativeAndTrackingData?.app_name || '';
  newTmpCreative.name = '';
  newTmpCreative.status = 0;
  newTmpCreative.icon = creativeAndTrackingData.app_icon ?? '';
  newTmpCreative.video_landscape = creativeAndTrackingData.store_video_url ?? '';
  newTmpCreative.icon_media_id = creativeAndTrackingData.app_icon_media_id ?? '';
  newTmpCreative.image = creativeAndTrackingData.app_image ?? '';
  newTmpCreative.image_media_id = creativeAndTrackingData.app_image_media_id ?? '';
  newTmpCreative.banners = [];
  newCreativeListData.push(newTmpCreative);
  const newTrackingforDefaultItem = structuredClone(NEW_CAMP_STAB_DEFAULT_TRACKING);
  newTrackingforDefaultItem.tmp_id = newTmpCreativeId;
  newTrackingforDefaultItem.bn_bannerid = newTmpCreativeId;
  dispatch(creativesActions.setCreativesList(newCreativeListData));
  dispatch(creativesActions.addTrackingDataForCreative(newTrackingforDefaultItem));
};
